import React, { useState, useEffect } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { InfoCircle } from "react-bootstrap-icons";
import { Form, InputGroup } from "react-bootstrap";

function InputType({ opt, label, id, showname, min, max, unit, value, onChange,readOnly = false  }) {
  // const handleValueChange = (e) => {
  //   onChange(id, e.target.value, unit);
  // };

  const handleValueChange = (e) => {
    if (!readOnly) { // Only allow changes if not read-only
      onChange(id, e.target.value, unit);
    }
  };

  return (
    <div className="position-relative">
      <label htmlFor={id} className="form-label d-flex align-items-center">
        {label}
        <span id={id} className="ms-1 text-muted">{opt}</span>
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id={`tooltip-${id}`}>{showname} ({min} to {max}) {unit}</Tooltip>}
        >
          <span className="ms-2 text-primary" style={{ cursor: "pointer" }}>
            <InfoCircle size={16} />
          </span>
        </OverlayTrigger>
      </label>
      <input
        type="number"
        id={id}
        className="form-control"
        min={min}
        max={max}
        value={value}
        onChange={handleValueChange}
        readOnly={readOnly} 
      />
    </div>
  );
}

function InputType1({ label, id, showname, min, max, unit, value, unitType, onChange, opt, readOnly=false}) {
  const [inputValue, setInputValue] = useState(value || "");
  const [currentUnit, setCurrentUnit] = useState(unitType || unit);

  useEffect(() => {
    setInputValue(value);
    setCurrentUnit(unitType);
  }, [value, unitType]);

  // const handleValueChange = (e) => {
  //   setInputValue(e.target.value);
  //   onChange(id, e.target.value, currentUnit);
  // };
  const handleValueChange = (e) => {
    if (!readOnly) { // Only allow changes if not read-only
      onChange(id, e.target.value, currentUnit);
    }
  };

  const toggleUnit = () => {
    let newValue = inputValue;
    let newUnit = currentUnit;

    if (currentUnit === "Cm") {
      newValue = inputValue ? (parseFloat(inputValue) * 0.0328084).toFixed(2) : "";
      newUnit = "Ft";
    } else if (currentUnit === "Ft") {
      newValue = inputValue ? (parseFloat(inputValue) * 30.48).toFixed(2) : "";
      newUnit = "Cm";
    } else if (currentUnit === "Kg") {
      newValue = inputValue ? (parseFloat(inputValue) * 2.20462).toFixed(2) : "";
      newUnit = "Lbs";
    } else if (currentUnit === "Lbs") {
      newValue = inputValue ? (parseFloat(inputValue) * 0.453592).toFixed(2) : "";
      newUnit = "Kg";
    }

    setInputValue(newValue);
    setCurrentUnit(newUnit);
    onChange(id, newValue, newUnit);
  };

  return (
    <div className="position-relative">
      <label htmlFor={id} className="form-label d-flex align-items-center">
        {label}
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id={`tooltip-${id}`}>{showname} ({min} to {max}) {currentUnit}</Tooltip>}
        >
          <span className="ms-2 text-primary" style={{ cursor: "pointer" }}>
            <InfoCircle size={16} />
          </span>
        </OverlayTrigger>
      </label>
      <InputGroup className="mb-3">
        <Form.Control
          id={id}
          type="number"
          value={inputValue}
          onChange={handleValueChange}
          min={min}
          max={max}
          aria-label={label}
          readOnly={readOnly} 
        />
        <InputGroup.Text style={{ cursor: "pointer" }} onClick={toggleUnit}>
          {currentUnit}
        </InputGroup.Text>
      </InputGroup>
    </div>
  );
}

function InputType2({ label, id, showname, min, max, unit, value, unitType, onChange, opt,readOnly=false }) {
  const [inputValue, setInputValue] = useState(value || "");
  const [currentUnit, setCurrentUnit] = useState(unitType || unit);

  useEffect(() => {
    setInputValue(value);
    setCurrentUnit(unitType);
  }, [value, unitType]);

  // const handleValueChange = (e) => {
  //   setInputValue(e.target.value);
  //   onChange(id, e.target.value, currentUnit);
  // };

  const handleValueChange = (e) => {
    if (!readOnly) { // Only allow changes if not read-only
      onChange(id, e.target.value, currentUnit);
    }
  };

  const toggleUnit = () => {
    let newValue = inputValue;
    let newUnit = currentUnit;

    if (currentUnit === "mg/dL") {
      newValue = inputValue ? (parseFloat(inputValue) / 18).toFixed(2) : "";
      newUnit = "mmol/L";
    } else if (currentUnit === "mmol/L") {
      newValue = inputValue ? (parseFloat(inputValue) * 18).toFixed(2) : "";
      newUnit = "mg/dL";
    }

    setInputValue(newValue);
    setCurrentUnit(newUnit);
    onChange(id, newValue, newUnit);
  };

  return (
    <div className="position-relative">
      <label htmlFor={id} className="form-label d-flex align-items-center">
        {label}
        <span id={id} className="ms-1 text-muted">{opt}</span>
        <OverlayTrigger
          placement="auto"
          overlay={
            <Tooltip id={`tooltip-${id}`} style={{ maxWidth: "250px", wordWrap: "break-word" }}>
              {showname} 
            </Tooltip>
          }
        >
          <span className="ms-2 text-primary" style={{ cursor: "pointer" }}>
            <InfoCircle size={16} />
          </span>
        </OverlayTrigger>
      </label>
      <InputGroup className="mb-3">
        <Form.Control
          id={id}
          type="number"
          value={inputValue}
          onChange={handleValueChange}
          min={min}
          max={max}
          aria-label={label}
          readOnly={readOnly}
        />
        <InputGroup.Text style={{ cursor: "pointer" }} onClick={toggleUnit}>
          {currentUnit}
        </InputGroup.Text>
      </InputGroup>
    </div>
  );
}

export { InputType, InputType1, InputType2 };
